import React from "react";
import { useTranslate } from "hooks/translation-hooks";
import Modal from "./GenericModal";
import { useDispatch, useSelector } from "react-redux";
import { continueModalOpenSelector } from "redux/selectors/modals";
import { hideModal } from "redux/actions/modalActions";
import { Body, Button, Buttons, Title } from "./ModalsStyled";

const ContinueModal = ({ doneWithPictures }) => {
  const t = useTranslate();
  const dispatch = useDispatch();
  const open = useSelector(continueModalOpenSelector);
  const handleClose = () => {
    dispatch(hideModal({ type: "continue" }));
  };
  const accept = () => {
    doneWithPictures();
    handleClose();
  };

  return (
    <Modal open={open} handleClose={handleClose}>
      <Title>{t("warning-modal_title")}</Title>
      <Body>{t("warning-modal_body")}</Body>
      <Buttons>
        <Button onClick={handleClose} data-testid="close-modal-button">
          {t("warning-modal_decline")}
        </Button>
        <Button onClick={accept} data-testid="accept-modal-button">
          {t("warning-modal_accept")}
        </Button>
      </Buttons>
    </Modal>
  );
};

export default ContinueModal;
